import React from "react";

export default class AppErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Application render failed", error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <main style={{ padding: "32px 20px", fontFamily: "sans-serif" }}>
          <h1>Не удалось открыть приложение</h1>
          <p>Попробуйте перезагрузить страницу.</p>
          <button type="button" onClick={() => window.location.reload()}>Перезагрузить</button>
        </main>
      );
    }

    return this.props.children;
  }
}
